/** Polski opis błędu getUserMedia (po nazwie wyjątku DOM). */
export function describeMediaError(name: string): string {
  switch (name) {
    case 'NotAllowedError':
    case 'SecurityError':
      return 'Brak zgody na mikrofon — blokuje go przeglądarka albo system (Windows: Ustawienia → Prywatność → Mikrofon; macOS: Ustawienia → Prywatność i ochrona → Mikrofon).';
    case 'NotFoundError':
    case 'OverconstrainedError':
      return 'Nie znaleziono żadnego mikrofonu.';
    case 'NotReadableError':
    case 'AbortError':
      return 'Mikrofon jest zajęty przez inną aplikację (np. Teams, Zoom) albo nie da się go uruchomić.';
    default:
      return `Nieznany błąd mikrofonu (${name}).`;
  }
}

/** Szczytowy poziom sygnału 0–100 z próbek czasowych AnalyserNode (bajty 0–255, cisza = 128). */
export function peakPercent(samples: ArrayLike<number>): number {
  let peak = 0;
  for (let i = 0; i < samples.length; i++) peak = Math.max(peak, Math.abs((samples[i] ?? 128) - 128));
  return Math.round((peak / 128) * 100);
}

/** Ocena szczytowego poziomu sygnału podczas mówienia do mikrofonu. */
export function levelVerdict(peak: number): { ok: boolean; text: string } {
  if (peak >= 15) return { ok: true, text: `Poziom sygnału: ${peak}% — dobrze, mikrofon Cię słyszy.` };
  if (peak >= 5) return { ok: false, text: `Poziom sygnału: ${peak}% — bardzo cicho. Zwiększ głośność wejścia w systemie albo mów bliżej mikrofonu.` };
  return { ok: false, text: `Poziom sygnału: ${peak}% — praktycznie cisza. Mów głośno w trakcie testu; jeśli to nie pomaga, mikrofon jest wyciszony albo wybrano złe wejście w systemie.` };
}
